var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step-inner-content" },
      [
        _c("SelectWrapper", {
          staticClass: "bgr",
          attrs: { item: "Video On Demand" },
          model: {
            value: _vm.Global.mockupConfig.content.vod,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.content, "vod", $$v)
            },
            expression: "Global.mockupConfig.content.vod",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          staticClass: "bgr",
          attrs: { item: "Live 24x7" },
          model: {
            value: _vm.Global.mockupConfig.content.live,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.content, "live", $$v)
            },
            expression: "Global.mockupConfig.content.live",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          staticClass: "bgr",
          attrs: { item: "Live Events" },
          model: {
            value: _vm.Global.mockupConfig.content.events,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.content, "events", $$v)
            },
            expression: "Global.mockupConfig.content.events",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          staticClass: "bgr",
          attrs: { item: "Start Over & Replay" },
          model: {
            value: _vm.Global.mockupConfig.content.replay,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.content, "replay", $$v)
            },
            expression: "Global.mockupConfig.content.replay",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          staticClass: "bgr",
          attrs: { item: "Podcast" },
          model: {
            value: _vm.Global.mockupConfig.content.podcast,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.content, "podcast", $$v)
            },
            expression: "Global.mockupConfig.content.podcast",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nxt-out" },
          [
            _c("div", { staticClass: "bgout" }),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "btn bck", attrs: { tag: "div", to: "/infos" } },
              [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "btn main txt-blk",
                attrs: { tag: "div", to: "/model" },
              },
              [
                _c("span", { staticClass: "hvr" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro-block" }, [
      _c("h5", { staticClass: "txt-grt" }, [_vm._v("Which content ?")]),
      _vm._v(" "),
      _c("p", [_vm._v("Choose the type of content that you want to deliver")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }